const state = {
  cacheViews: []
}

const mutations = {
  // 添加组件缓存
  ADD_CACHED_VIEW(state, name) {
    if (!name || state.cacheViews.includes(name)) return
    state.cacheViews.push(name)
  },
  // 删除组件缓存
  DEL_CACHED_VIEW(state, name) {
    state.cacheViews = state.cacheViews.filter(
      item => item !== name
    )
  },
  // 清空缓存
  CLEAR_CACHED_VIEWS(state) {
    state.cacheViews = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
